import {
    LSYNCD_REQUEST_GET,
    LSYNCD_RESPONSE_GET_SUCCESS,
    LSYNCD_RESPONSE_GET_FAIL,

  } from "../../../constants/maintenance/systemHealth/lsyncdConstants";
  
  export const lsyncdShReducer = (state = { lsyncd: {} }, action) => {
    switch (action.type) {
      case LSYNCD_REQUEST_GET:
        return {
          ...state,
          loading: true,
        };
      case LSYNCD_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          lsyncd: action.payload,
        };
      case LSYNCD_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  